import React from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";

import { Label } from "./BaseItemTitle.styles";
import { Row, VisibilityIcon } from "./Legend.styles";

interface BaseItemTitleProps {
  title: string;
  isVisible: boolean;
  className?: string | undefined;
  onItemVisibilityToggle?: (mode: "self" | "siblings") => void;
  leftAdornment?: React.ReactNode;
  rightAdornment?: React.ReactNode;
}

const BaseItemTitle: React.FC<BaseItemTitleProps> = ({ title, isVisible, className, onItemVisibilityToggle, leftAdornment, rightAdornment }) => {
  /**
   * Toggles an individual layers visibility setting & prevents row selection propagation
   */
  const handleOnVisibilityClick = (e: React.MouseEvent) => {
    e.stopPropagation();

    // Shift-clicking the visibility icon toggles all siblings (not the item itself)
    const mode = e.shiftKey ? "siblings" : "self";
    onItemVisibilityToggle?.(mode);
  };

  return (
    <Row isVisible={isVisible} className={className}>
      {leftAdornment}
      <Label>{title}</Label>
      {rightAdornment}
      {onItemVisibilityToggle !== undefined && (
        <VisibilityIcon isVisible={isVisible} onClick={handleOnVisibilityClick}>
          {isVisible ? <Visibility data-testid="visible-icon" /> : <VisibilityOff data-testid="invisible-icon" />}
        </VisibilityIcon>
      )}
    </Row>
  );
};

export default BaseItemTitle;
